import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityLink } from "~/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const StyledEntityLink = styled(EntityLink)``;

export const TitleBar = styled.div`
  border-block-start: 1px solid #333333;

  inline-size: 60px;
  block-size: 2px;
  margin-block: 24px 11px;
  margin-inline: 0;
`;

export const Section = styled.div`
  color: #000000;
  font-weight: normal;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

export const Headline = styled.div`
  margin-block: 8px;
  margin-inline: 0;

  color: #777777;
  font-weight: normal;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;

  &:hover {
    color: #2c4692;
  }
`;

export const UpdateDate = styled.div`
  color: #999999;
  font-weight: normal;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
`;

export const StyledBaseImage = styled(BaseImage)`
  padding-block: 12px;
  padding-inline: 0;
`;
